import { CENTRA_LANGUAGE_CODE, CentraLanguageCode } from "@/data/supported-languages"
import { CENTRA_MARKET_CODE, CentraMarketCode } from "@/data/supported-markets"

export type MarketCodeToDefaultLangaugeMap = Map<CentraMarketCode, CentraLanguageCode>

const marketCodeToDefaultLanguage: MarketCodeToDefaultLangaugeMap = new Map<
    CentraMarketCode,
    CentraLanguageCode
>([
    [CENTRA_MARKET_CODE.Jp, CENTRA_LANGUAGE_CODE.Ja],
    [CENTRA_MARKET_CODE.Eu, CENTRA_LANGUAGE_CODE.En],
    [CENTRA_MARKET_CODE.Na, CENTRA_LANGUAGE_CODE.En],
    [CENTRA_MARKET_CODE.Apac, CENTRA_LANGUAGE_CODE.En]
])

export default marketCodeToDefaultLanguage
